import React, { useState } from "react";
import { AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import { FaBars } from "react-icons/fa"; // Import the hamburger icon
import SmallNavbar from "./SmallNavbar";
import NavMenu from "./NavMenu";
import MobileMenu from "./MobileMenu";
import { navData } from "../../Data/Data";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    setMobileMenuOpen(open);
  };

  return (
    <>
      {/* Small Navbar */}
      <SmallNavbar />

      {/* Main Navbar */}
      <AppBar position="sticky" className="!bg-white !shadow-md py-0 !overflow-visible">
        <Toolbar className="container mx-auto flex justify-between px-4 lg:px-6 max-w-full">
          <Typography variant="h6" className="text-black flex-shrink-0">
            <Link to="/" className="text-blue-700">
              <img src="/Logo.png" alt="Logo" className="h-16 w-auto" />
            </Link>
          </Typography>
          <NavMenu data={navData} />
          <div className="lg:hidden flex-shrink-0">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
              className="!p-2"
            >
              <FaBars className="text-black" />
            </IconButton>
            <MobileMenu
              open={mobileMenuOpen}
              toggleDrawer={toggleDrawer}
              data={navData}
            />
          </div>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Navbar;
